const threeSumWithHashing = (arr, sum) => {
  const map = new Map();

  // Add element along with its index in the hashmap
  for (let i = 0; i < arr.length; i++) {
    map.set(arr[i], i);
  }

  // check each pair
  // we ignore last element because we need a triplet (pair + 1 element).
  for (let i = 0; i < arr.length - 1; i++) {
    for (let j = i + 1; j < arr.length; j++) {
      //pending sum
      let val = sum - (arr[i] + arr[j]);

      // there is a triplet, if we pending sum is available in the map
      if (map.has(val)) {
        // if it is unique, return true
        if (map.get(val) !== i && map.get(val) !== j) {
          return true;
        }
      }
    }
  }

  // return false, if there is no triplet
  return false;
};

export default threeSumWithHashing;
